/**
 * Obtiene el valor de una variable CSS.
 * @param variableName - El nombre de la variable CSS.
 * @returns El valor de la variable CSS.
 */
export const getCssVariable = (variableName: string): string => {
  return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
};

/**
 * Extrae la URL de una cadena de estilo CSS.
 * @param cssValue - El valor de la propiedad CSS que contiene la URL.
 * @returns La URL extraída de la cadena de estilo CSS.
 */
export const extractUrlFromCssValue = (cssValue: string): string => {
  return cssValue.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
};

/**
 * Obtiene la URL de una variable CSS.
 * @param variableName - El nombre de la variable CSS.
 * @returns La URL extraída de la variable CSS.
 */
export const getUrlFromCssVariable = (variableName: string): string => {
  const cssValue = getCssVariable(variableName);
  return extractUrlFromCssValue(cssValue);
};
